<template>
  <div class="intelligentAgriculture-page szxc allShareAac">
    <!-- 数字乡村-->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/allShareAac/banner.webp">            
            </div>
            <div class="mid-body"  style="background:rgba(246,247,250,1);margin-bottom: 0;padding-top: 40px;">
                <div class="mid-body-box">
                    <h2 style="text-align: left;margin-bottom: 10px;margin-top: 80px;font-size: 30px;font-weight: 500;margin-left: 20px;">百倍云共享田园解决方案</h2>
                    <div>
                        <div class="left-box">
                            <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/allShareAac/index01.webp">    
                         </div>
                        <div class="left-box">
                            <p style="font-size: 16px;letter-spacing: 2px;color: #666;line-height: 24px;">十九大报告中强调“在中高端消费、创新引领、绿色低碳、共享经济、现代供应链、人力资本服务等领域培育新的增长点、形成新动能；共享田园是利用共享经济，盘活乡村闲置资源，提高农民收入，实现乡村现代化，推动乡村振兴的重要举措。百倍云共享田园通过农用地认养，为城市人群打造体验乡村生产生活的平台，实现区域内特色农产品和优质旅游资源串联成势。同时，采取跨区域多村共营方式，搭建特色农产品、优质旅游资源的协同。发展平台，通过市场化运作，为乡村导入更多人流。</p>
                        </div>
                    </div>
                </div>    
            </div> 

            
            <div class="mid-body" style="position:relative;height:1000px">
                <p class="szxc-title">百倍云共享田园</p>
                <p style="font-size: 20px;
    width: 1200px;
    margin: auto;
    text-align: left;
    position: relative;
    bottom: 20px;
    left: 29px;">百倍云共享田园以易用性，实用性为宗旨，致力打造好用的田园共享功能应用，目前有田园地块在线认养，农作物模型库，专家指导，特产商城，远程物联网田园环境监控、查看及控制功能。</p>

                <img style="width:100%;height:auto;margin-top: 160px;" src="../../assets/img/caseDetails/allShareAac/bg2.webp">    
                <div class="mid-body-box" style="position: absolute;top: 172px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/allShareAac/bg1.webp">                                   
                        <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 109px;"> 
                            <p style="margin-bottom: 10px;font-size: 26px;font-weight: 700;margin-top: 16px;">田园认养</p>     
                            <span style="display: block;font-size: 12px;width: 100%;">认养田园，在线签订认养协议 </span>                
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 10px;font-size: 26px;font-weight: 700;margin-top: 16px;">环境监测</p>
                            <span style="display: block;font-size: 12px;width: 100%;">远程视频，环境数据 </span> 
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 10px;font-size: 26px;font-weight: 700;margin-top: 16px;">远程灌溉</p>
                            <span style="display: block;font-size: 12px;width: 100%;">土壤墒情监测，远程灌溉</span> 
                        </div>
                              
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="position:relative;height:680px">
                <img style="width:100%;height:auto;margin-top: 240px;" src="../../assets/img/caseDetails/allShareAac/bg4.webp">    
                <div class="mid-body-box" style="position: absolute;top: -160px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/allShareAac/bg3.webp">                                   
                         <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 109px;"> 
                            <p style="margin-bottom: 10px;font-size: 26px;font-weight: 700;margin-top: 16px;">农事活动</p>
                            <span style="display: block;font-size: 12px;width: 100%;">在线报名，农事体验 </span>             
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 10px;font-size: 26px;font-weight: 700;margin-top: 16px;">乡村游玩</p>
                            <span style="display: block;font-size: 12px;width: 100%;">吃喝玩乐，周边推荐 </span>             
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 10px;font-size: 26px;font-weight: 700;margin-top: 16px;">特产商城</p>
                            <span style="display: block;font-size: 12px;width: 100%;">田园农场，特产在线 </span>             
                        </div>
                              
                    </div>
                </div>    
            </div> 
        
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
        shownav:false,
        select:1,
    }
  },
  mounted() {
      this.changetitle()
  },
  methods: {
      clicknav(e){
          this.select = e
      },
          changetitle(){//http://www.100byun.com  http://100byun.com使用这个域名访问官网时，底部的备案信息需要更换下，其它访问方式时，底部备案信息还是跟当前一样不变
    var url = window.location.href
     this.shownav = true
    // if(url.split("/#/")[0] == "http://www.100byun.com"||url.split("/#/")[0] == "http://100byun.com"){
    //   this.shownav = false
    // }else{
    //   this.shownav = true
        
    // }
    },
  }
}
</script>
<style>
    .allShareAac .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .allShareAac .mid-body{
        margin-bottom: 120px;
    }
    .allShareAac .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .allShareAac .four-box{
        width: 25%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .allShareAac .list-box{
     box-sizing: border-box;
    padding: 20px;
    position: relative;
    text-align: left;
    padding-left: 240px;
        
    }
    .allShareAac .list-box img{
        width: 24px;
        height: auto;
        position: absolute;
        left: 190px;
        top: 21px;
    }
    .allShareAac .list-box p{
        margin-bottom: 14px;
    }
    .allShareAac .five-box{
        width: 20%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
    }
    .allShareAac .five-box img{
            width: 50px;
    height: auto;
    margin: auto;
    cursor: pointer;
    }
        .allShareAac .five-box span{
         display: inline-block;
        padding-top: 22px;
        padding-bottom: 32px;
        font-size: 18px;
        font-weight: bold;
        color: #8993a7;
        line-height: 1em;
        border-bottom: 3px solid transparent;
        cursor: pointer;
    }
   
   .allShareAac .mid-body-box .three-box{
        width: 33% !important;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
            height: 100px;
    margin: 0;
    }
    .allShareAac .mid-body-box .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
    }
    .allShareAac .nav-box{
        width: 100%;
        border: 1px solid #dbe0e5;
        box-sizing: border-box;
        padding: 40px;
    }
    .allShareAac .nav-box .list{
        width: 100%;
        margin-bottom: 20px;
        text-align: left;
    }
    .allShareAac .list-item{
        padding: 12px 20px;
        color: #8993a7;
        margin-right: 20px;
        margin-bottom: 20px;
        display: inline-block;
        background: #ffffff;
        border: 1px solid #d0d7e1;
        -webkit-box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        min-width: 120px;
        text-align: center;
        position: relative;
            font-size: 12px;
    width: 150px;
    }
    .allShareAac .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

    .allShareAac .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
        .allShareAac .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
   .allShareAac .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
    .allShareAac .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
    .allShareAac .active{
        border-bottom: 3px solid #f8a811 !important;
        color: #333 !important;
    }
    .allShareAac .szxc-title{
        width: 1200px;
    margin: auto;
    line-height: 137px;
    text-align: left;
    padding-left: 25px;
    font-size: 30px;
    font-weight: 500;
        padding-top: 20px;
    }

</style>